import React from 'react';
import _ from 'lodash';
import Isvg from 'react-inlinesvg';
import DownArrowIcon from 'app/images/icons/down-arrow.svg';



interface ICardTitleProps {
  children?: React.ReactNode;
  notification: string;
  onClick: any;
  withArrow: boolean;
  isOpen: boolean;
}

export default class CardTitle extends React.Component<ICardTitleProps> {
  static defaultProps: ICardTitleProps = {
    notification: undefined,
    onClick: undefined,
    withArrow: false,
    isOpen: false,
  };

  renderNotification() {
    if (!_.isEmpty(this.props.notification)) {
      return (
        <div className="col card-notification-col text-right">
          <span className="color-green">{this.props.notification}</span>
        </div>
      );
    }
    return null;
  }

  render(): React.ReactNode {
    return (
      <div className="row card-title" onClick={this.props.onClick}>
        <div className="col card-title-col">
          <span>{this.props.children}</span>
          {this.props.withArrow && <Isvg className="card-group-tile-down-icon" src={DownArrowIcon} />}
        </div>
        {this.renderNotification()}
      </div>
    );
  }
}
